export default __webpack_public_path__ + "static/media/pulse-intro.863ee2b7.svg";